module.exports = __webpack_public_path__ + "static/media/recipe.d4a6f047.jpg";